const PRICE_HIDDEN_RESTAURANT_SLUGS = new Set([
  'bci_marines',
  'army_dinex',
  'the-exchange-kpmg-lakehouse',
]);

export const shouldHideGuestPrices = (restaurantUrlSlug?: string) =>
  restaurantUrlSlug
    ? PRICE_HIDDEN_RESTAURANT_SLUGS.has(restaurantUrlSlug.toLowerCase())
    : false;

export default shouldHideGuestPrices;
